import { FILTER_SEPARATOR, FILTER_VALUE_SEPARATOR } from "go-list/core/components/Filter/services";

export const camelToSnakeCase = (str: string, toLowerCase = false): string =>
	toLowerCase
		? str?.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`).toLowerCase()
		: str?.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`).toUpperCase();

export const snakeToCamelCase = (str: string) =>
	str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("_", ""));

export const getFilterValuesForDefinedValues = (
	data: Record<string, any>,
	getResourceTranslation: (id: string) => string | undefined,
	filterName: string
) => {
	const { search } = location;
	const urlSearchParams = new URLSearchParams(search);
	const fParam = urlSearchParams.get("f");
	if (!fParam) return;

	let decodedFParam = "";
	try {
		decodedFParam = decodeURIComponent(escape(atob(fParam)));
	} catch (err) {
		return "";
	}

	const filters = decodedFParam.split(FILTER_SEPARATOR);
	const resourceTypeFilter = filters.find((filter) => filter.includes(filterName));
	if (!resourceTypeFilter) return;

	const resourceTypeFilterValueIndex = resourceTypeFilter.indexOf("=") + 1;
	const resourceTypeFilterValues = resourceTypeFilter?.substring(resourceTypeFilterValueIndex);
	const resourceTypeFilterValuesAsArray = resourceTypeFilterValues?.split(FILTER_VALUE_SEPARATOR);

	data.filter_values = [];

	resourceTypeFilterValuesAsArray?.forEach((filterValue) => {
		data.filter_values.push({
			id: filterValue,
			field_name: filterName,
			value: {
				name: getResourceTranslation(filterValue),
			},
		});
	});
};
